import React from "react"
import { Button, Box, Tip } from "grommet"
import {
  useCheckinMutation,
  useCheckoutMutation,
  useGetStatusQuery,
} from "../redux/timesheetsSlice"
import { Stopwatch } from "./Stopwatch"
import { DateTime } from "luxon"

import { isAllowedTime } from "./AllowedHours"

const TimesheetControls = () => {
  const { data: status, isLoading } = useGetStatusQuery()
  const [checkin] = useCheckinMutation()
  const [checkout] = useCheckoutMutation()

  const handleButtonClick = React.useCallback(async () => {
    if (!status) return

    if (!isAllowedTime()) {
      alert(
        "Impossible d'enregistrer votre arrivée en dehors des horaires autorisés"
      )
      return
    }

    if (status?.current_status === "in") {
      if (window.confirm("Voulez-vous enregistrer votre départ ?")) {
        await checkout()
      }
    } else {
      if (window.confirm("Voulez-vous enregistrer votre arrivée ?")) {
        await checkin()
      }
    }
  }, [checkin, checkout, status])

  if (isLoading || !status) return null

  const isAllowed = isAllowedTime()

  const button = (
    <Button
      color={status.current_status === "out" ? "brand" : "status-ok"}
      size="xsmall"
      onClick={handleButtonClick}
      disabled={!isAllowed}
      label={
        <>
          {status.current_status === "out" ? "Arrivée" : "Départ"}
          {status.current_status === "in" && (
            <Stopwatch
              start={status.last_timesheet.started_at}
              margin={{ left: "xsmall" }}
            />
          )}
        </>
      }
    />
  )

  return (
    <>
      {!isAllowed ? (
        <Tip content={"Bouton désactivé entre 19h et 7h"}>
          <Box>{button}</Box>
        </Tip>
      ) : (
        <Box>{button}</Box>
      )}
    </>
  )
}

export { TimesheetControls }
//*/
